import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export const actionTypes = {
  getAllPassengers: "[getAllPassengers] Action",
  createPassenger: "[createPassenger] Action",
  updatePassenger: "[updatePassenger] Action",
  deletepassenger: "[deletepassenger] Action",
};

export const initialPassengersState = {
  passengers: [],
  passenger: {},
  isPassengersLoaded: false,
};

export const reducer = persistReducer(
  { storage, key: "v705-demo1-crm", whitelist: ["user", "recommends"] },
  (state = initialPassengersState, action) => {
    switch (action.type) {
      case actionTypes.getAllPassengers: {
        initialPassengersState.passengers = action.payload;
        return initialPassengersState;
      }

      default:
        return state;
    }
  }
);

export const actions = {
  getAllPassengers: (passengers) => ({
    type: actionTypes.getAllPassengers,
    payload: passengers,
  }),
  createPassenger: (passenger) => ({
    type: actionTypes.createPassenger,
    payload: passenger,
  }),
  updatePassenger: (passenger) => ({
    type: actionTypes.updatePassenger,
    payload: passenger,
  }),
  deletePassenger: (passenger) => ({
    type: actionTypes.deletepassenger,
    payload: passenger,
  }),
};
